// extracted by mini-css-extract-plugin
export var availableAt = "source-cite-module--availableAt--03efa";
export var citeContainer = "source-cite-module--citeContainer--7751b";
export var citeDate = "source-cite-module--citeDate--1e529";
export var citeHeader = "source-cite-module--citeHeader--b358c";
export var citeUrl = "source-cite-module--citeUrl--351c4";
export var genericContainer = "source-cite-module--genericContainer--31bfb";
export var webSiteName = "source-cite-module--webSiteName--a3c99";